import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import helps from './helps'; // helps.js からデータをインポート
import categories from './categories'; // categories.js からカテゴリデータをインポート
import './HelpDetailPage.css';


const HelpDetailPage = () => {
  const { id } = useParams();

  // 選択されたプロンプトを取得
  const help = helps.find((p) => p.id === id);

  // 推奨プロンプトを格納するstate
  const [recommendedHelps, setRecommendedHelps] = useState([]);
  const getWeightedRandomSelection = (items, count) => {
    // スコアに基づく重み付きリストを作成
    const weightedItems = items.flatMap((item) => Array(item.score).fill(item));
  
    const selected = [];
    const usedIds = new Set(); // 選択された投稿のIDを記録
  
    while (selected.length < count && weightedItems.length > 0) {
      const randomIndex = Math.floor(Math.random() * weightedItems.length);
      const selectedItem = weightedItems[randomIndex];
  
      if (!usedIds.has(selectedItem.id)) {
        selected.push(selectedItem);
        usedIds.add(selectedItem.id); // 選択済みIDを記録
      }
  
      // 選ばれた投稿をリストから削除
      weightedItems.splice(randomIndex, 1);
    }
  
    return selected;
  };

  
  useEffect(() => {
    if (help) {
      const related = helps
        .filter((p) => p.id !== help.id) // 自分自身を除外
        .map((p) => {
          let score = 1;
  
          // 大カテゴリ一致 → +5（優先度を高く設定）
          if (p.largeCategory === help.largeCategory) {
            score += 5;
          }
  
          // 中カテゴリの一致数 → +2/一致
          const matchingMiddleCategories = p.middleCategory.filter((cat) =>
            help.middleCategory.includes(cat)
          );
          score += matchingMiddleCategories.length * 2;
  
          // 他のスコアロジックを追加する場合はここに
          return { ...p, score }; // スコアを追加
        });
  
      // ランダムに選択（最大5件）
      const randomSelection = getWeightedRandomSelection(related, 5);
      setRecommendedHelps(randomSelection);
    }
  }, [help]);

  if (!help) {
    return (
      <div className="help-detail-page">
        <h2>Help not found</h2>
        <Link to="/helps" className="back-link">
          Back to Help List
        </Link>
      </div>
    );
  }

  return (
    <div className="help-detail-page">
      <div className="detail-header">
        <h1 className="detail-title">
          <span className="category-icon">
            {categories[help.largeCategory]?.icon}
          </span>
          <span className="title-text">{help.title}</span>
        </h1>
      </div>
  
      <div className="detail-section">

      <div className="help-box">
        {typeof help.description === 'string'
          ? help.description.split('\n').map((line, index) => (
              <p key={index}>{line}</p>
            ))
          : <p>{help.description}</p>}
      </div>
      </div>
  
      <div className="detail-section">
        <h2 className="section-title">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#EAC452"><path d="M480-80q-26 0-47-12.5T400-126q-33 0-56.5-23.5T320-206v-142q-59-39-94.5-103T190-590q0-121 84.5-205.5T480-880q121 0 205.5 84.5T770-590q0 77-35.5 140T640-348v142q0 33-23.5 56.5T560-126q-12 21-33 33.5T480-80Zm-80-126h160v-36H400v36Zm0-76h160v-38H400v38Zm-8-118h58v-108l-88-88 42-42 76 76 76-76 42 42-88 88v108h58q54-26 88-76.5T690-590q0-88-61-149t-149-61q-88 0-149 61t-61 149q0 63 34 113.5t88 76.5Zm88-162Zm0-38Z" />
          </svg>
          回答
        </h2>
        <div className="help-box">
          {typeof help.help === 'string' ? (
            help.help.split('\n').map((line, index) => <p key={index}>{line}</p>)
          ) : (
            <p>{help.help}</p> // JSXの場合はこちらがレンダリングされます
          )}
        </div>
      
      </div>

        {recommendedHelps.length > 0 && (
        <div className="detail-section">
            <h2 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5084C1"><path d="m80-520 200-360 200 360H80Zm200 400q-66 0-113-47t-47-113q0-67 47-113.5T280-440q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T360-280q0-33-23.5-56.5T280-360q-33 0-56.5 23.5T200-280q0 33 23.5 56.5T280-200Zm-64-400h128l-64-115-64 115Zm304 480v-320h320v320H520Zm80-80h160v-160H600v160Zm80-320q-57-48-95.5-81T523-659q-23-25-33-47t-10-47q0-45 31.5-76t78.5-31q27 0 50.5 12.5T680-813q16-22 39.5-34.5T770-860q47 0 78.5 31t31.5 76q0 25-10 47t-33 47q-23 25-61.5 58T680-520Zm0-105q72-60 96-85t24-41q0-13-7.5-21t-20.5-8q-10 0-19.5 5.5T729-755l-49 47-49-47q-14-14-23.5-19.5T588-780q-13 0-20.5 8t-7.5 21q0 16 24 41t96 85Zm0-78Zm-400 45Zm0 378Zm400 0Z"/></svg>
            関連
            </h2>
            
            <div className="recommended-container">
              {recommendedHelps.map((rec) => (
                <div
                  key={rec.id}
                  className="recommended-card"
                  onClick={() => (window.location.href = `/helps/${rec.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <h3>{rec.title}</h3>
                </div>
              ))}
            </div>
        </div>
        )}
        

        <Link to="/helps" className="back-link">
            &larr; Top
        </Link>
    </div>
  );
};

export default HelpDetailPage;